export class NICEUserPermissions {
    public permissions: Map<string, string> = new Map();
    constructor(data: Array<any>) {
        data.forEach(item => {
            {
                this.permissions.set(item.Key, item.Value);
            }
        });
    }
}
